import { useEffect } from 'react';
import debounce from 'lodash/debounce';

/**
 * Closes a floating component when wrapper scrolls
 * @param state Whether the component is open or closed
 * @param closeFunction Component function that manipulates its internal state
 * @param scrollWrapper Parent wrapper that has scroll
 */
const useCloseOnScroll = (
  state: boolean,
  closeFunction: (open: false) => void,
  ...scrollWrappers: (HTMLElement | null | undefined)[]
) => {
  const debouncedCloseFunction = debounce(() => {
    if (state) closeFunction(false);
  }, 250);

  useEffect(() => {
    scrollWrappers.forEach(wrapper => {
      if (wrapper) wrapper.addEventListener('scroll', debouncedCloseFunction);
    });

    return () => {
      scrollWrappers.forEach(wrapper => {
        if (wrapper) wrapper.removeEventListener('scroll', debouncedCloseFunction);
      });
    };
  }, [scrollWrappers, debouncedCloseFunction]);
};

export default useCloseOnScroll;
